import{jsx as o,jsxs as a,Fragment as F}from"react/jsx-runtime";import t,{keyframes as I}from"styled-components";import{Display3 as Y,Title as q}from"../../typography/Heading/index.js";import{mq as m}from"../../shared/media-queries.js";const D=t.div`
  position: relative;
  min-height: 440px;
  display: flex;
  flex-direction: column;
`,M=I`
  0% {
    background-color:#f5f5f5;
  }

  50%{
    background-color: #e5e5e5
  }

  100% {
    background-color:#f5f5f5;
  }`,N=t.div`
  width: 100%;
  height: 440px;
  animation: ${M} 2s linear infinite;
`,P=t.div`
  pointer-events: ${({$pointerEvents:e})=>e};
  display: flex;
  flex-direction: ${({$direction:e})=>e};
  align-items: ${({$align:e})=>e};
  justify-content: ${({$justify:e})=>e};
  padding: 3rem 1.5rem;
  z-index: 1;
  flex: 1;
`,T=t.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`,d=e=>typeof e=="number",f=e=>typeof e=="string",X=({$positionX:e,$positionY:i})=>{if(d(e)&&d(i))return`${e}% ${i}%`;if(f(e)&&f(i))return`${e} ${i}`;if(e||i){const r=d(e)?`${e}%`:e,n=d(i)?`${i}%`:i;return`${r||"50%"} ${n||"50%"}`}return"50% 50%"},A=t.div`
  width: 100%;
  min-height: 440px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({$url:e,...i})=>e&&`
    background: url('${e}');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: ${X(i)};
  `}
`,B=t.div`
  padding-left: 1rem;
  padding-right: 1rem;
  z-index: 2;

  ${m("tablet")} {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
`,H=t.div`
  ${({$centered:e})=>e&&`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  `}

  ${({$maxWidth:e,$dynamicGutter:i})=>!i&&`
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    max-width: ${e}rem;
  `}

  ${({$dynamicGutter:e})=>e&&`
    ${m("tablet")} {
      margin-left: ${e.tabletVw}vw;
      margin-right: ${e.tabletVw}vw;
    }

    ${m("laptop")} {
      margin-left: ${e.laptopVw}vw;
      margin-right: ${e.laptopVw}vw;
    }
  `}
`,J=t(Y)`
  margin: 0;
  color: ${({$color:e,theme:i})=>i.colors.text[e]};

  ${({$shadow:e})=>e&&"text-shadow: 4px 4px 6px rgba(0, 0, 0, 0.2);"}
`,L=t(q)`
  margin: 0.25rem 0;
  color: ${({$color:e,theme:i})=>i.colors.text[e]};

  ${({$shadow:e})=>e&&"text-shadow: 4px 4px 6px rgba(0, 0, 0, 0.2);"}
`,O=t.div`
  display: inline-block;
  margin-top: 3rem;

  ${({$shadow:e,theme:i})=>e&&`box-shadow: ${i.elevations.elevation8};`}
`,K=({imageProps:e,imageElement:i,videoProps:r,children:n,align:u,direction:x,justify:w,contentMaxWidth:b=64,heading:l,headingColor:p="dark",subheading:s,button:$,dynamicGutter:y,isLoading:v=!1,contentCentered:k=!1,containerStyle:j,elementShadow:c=!1,childrenNoWrapper:h=!1})=>{const{autoplay:G=0,controls:V=0,disablekb:W=0,end:g,loop:z=0,modestbranding:E=1,start:S=0,showInfo:C=0}=r?.ytConfig||{};return v?o(N,{"data-testid":"loader"}):o(D,{style:j,children:r?o(T,{"data-testid":"hero-video",title:"video-frame",src:`${r.src}?disabledkb=${W}&autoplay=${G}&controls=${V}&loop=${z}&modestbranding=${E}&start=${S}&showInfo=${C}${g?`&end=${g}`:""}`,width:"100%",height:"100%",frameBorder:"0",allow:"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",allowFullScreen:!0}):a(A,{"data-testid":"hero-image",$positionX:i?void 0:e?.x,$positionY:i?void 0:e?.y,$url:i?void 0:e?.src,children:[i,a(B,{children:[(l||s||$)&&a(H,{$maxWidth:b,$dynamicGutter:y,$centered:k,children:[l&&o(J,{as:"h1",$color:p,$shadow:c,children:l}),s&&o(L,{$color:p,$shadow:c,children:s}),$&&o(O,{$shadow:c,children:$})]}),n&&a(F,{children:[!h&&o(P,{$pointerEvents:r?"none":"auto",$align:u||"flex-start",$direction:x||"column",$justify:w||"flex-start",children:n}),h&&n]})]})]})})};export{K as default};
